import directive from '@/plugin/directive/index';
import prototype from '@/plugin/prototype/index';

export default function (Vue) {
  directive(Vue);

  prototype(Vue);
}



// WEBPACK FOOTER //
// ../src/plugin/index.js